<template>
  <div class="auth-form-container">
    <internal-loading v-if="internalLoading"></internal-loading>
    <div class="auth-form" id="form-builder"></div>
    <el-button @click="onSubmit" class="auth-button">AVANÇAR</el-button>
    <router-link :to="{name:'FormEsqueciMinhaSenha'}" v-show="!internalLoading" class="auth-recuperar-link">ESQUECI
      MINHA SENHA
    </router-link>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { renderForm } from '@mobilesaude/form-builder-sdk'
import internalLoading from '../../shared/loading/InternalLoading'

export default {
  name: 'FormLogin',
  components: {
    internalLoading
  },
  data () {
    return {
      form: null,
      title: 'Acesse sua conta',
      subTitle: 'Entre com suas credenciais de acesso Mobile Saúde',
      buttonBack: true,
      routerName: 'FormValidaContexto',
      internalLoading: true
    }
  },
  mounted () {
    let params = {
      identifier: 'form-builder',
      clientKey: process.env.VUE_APP_CLIENTE_KEY,
      idForm: this.idsforms.formLogin,
      colors: {
        primary: '#0075EA',
        errors: '#ff4949'
      },
      json: {
        contexto: this.contexto.slug
      }
    }
    this.form = renderForm(params)
    this.form.on('LOADING', res => {
      this.internalLoading = res
    })
  },
  methods: {
    ...mapActions('login', [
      'validaLogin',
      'getIds'
    ]),
    onSubmit () {
      this.form.validateAll().then(form => {
        this.validaLogin(form.data)
      })
    }
  },
  computed: {
    ...mapState('login', [
      'loading', 'contexto', 'idsforms'
    ])
  },
  created () {
    this.getIds()
    this.$root.$emit('set-data-auth', {
      title: this.title,
      subTitle: this.subTitle,
      buttonBack: this.buttonBack,
      routerName: this.routerName
    })
  }
}
</script>
<style lang="sass" scoped>
  @import url('https://fonts.googleapis.com/css?family=Nunito&display=swap')
  @import '../../../views/auth/auth.scss'
</style>
